import { CohortDetails } from '@platform/client/schemas';
import {
  ProfileItem,
  ProfileLinkExternal,
  ProfileSection,
  ProfileTabContainer,
  CorporateDashboardProfileLink,
} from '../../components/ProfileComponents';
import { formatDateStr } from '../../../dashboard/my-projects/utils';

export const DetailsTabContent = ({ cohortData }: { cohortData?: CohortDetails | null }) => {
  return (
    <ProfileTabContainer>
      <ProfileSection title='Cohort Details' columns={1}>
        <CorporateDashboardProfileLink
          corporateClientId={cohortData?.clientId}
          corporateClientName={cohortData?.clientName}
          cohortId={cohortData?.id}
        />
        <ProfileItem label='Description' value={cohortData?.description} />
        <ProfileLinkExternal
          label='Url'
          href={cohortData?.url ? cohortData.url : undefined}
          shorten={false}
        />
      </ProfileSection>
      <ProfileSection title='Cohort Dates'>
        <ProfileItem
          label='App Start Date'
          value={
            cohortData?.applicationStartDate ?
              formatDateStr(cohortData.applicationStartDate)
            : undefined
          }
        />
        <ProfileItem
          label='Kickoff Date'
          value={cohortData?.kickoffDate ? formatDateStr(cohortData.kickoffDate) : undefined}
        />
        <ProfileItem
          label='App End Date'
          value={
            cohortData?.applicationEndDate ?
              formatDateStr(cohortData.applicationEndDate)
            : undefined
          }
        />
        <ProfileItem
          label='Engage Start Date'
          value={
            cohortData?.engagementStartDate ?
              formatDateStr(cohortData.engagementStartDate)
            : undefined
          }
        />
        <ProfileItem
          label='Available'
          value={cohortData?.available ? 'Yes' : 'No'}
          helpText='Applies only to SAP - determines determines if cohort is visible to users in the SAP application list'
        />
        <ProfileItem
          label='Engage End Date'
          value={
            cohortData?.engagementEndDate ? formatDateStr(cohortData.engagementEndDate) : undefined
          }
        />
        <div className='col-start-2'>
          <ProfileItem
            label='Wrap Up Date'
            value={cohortData?.wrapupDate ? formatDateStr(cohortData.wrapupDate) : undefined}
          />
        </div>
      </ProfileSection>
      <ProfileSection title='Cohort Template'>
        <ProfileItem label='Duration' value={cohortData?.duration} />
        <ProfileItem label='Time Commitment' value={cohortData?.timeCommitment} />
        <ProfileItem label='Format' value={cohortData?.template?.cohortType} />
      </ProfileSection>
    </ProfileTabContainer>
  );
};
